import { Experiments } from '../constants/experiments';

const { experiments } = window.__DATA__;

export const harmonyPatchValue = <T>(original: T, harmony: T) =>
  experiments.experiments[Experiments.BmHarmonyTheme] === 'B'
    ? harmony
    : original;
